import { Fragment } from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Products from "./pages/Products";
import Manual from "./pages/Manual";
import Cases from "./pages/Cases";
import Community from "./pages/Community";
import TopicDetail from "./pages/TopicDetail";
import Contact from "./pages/Contact";
import Trial from "./pages/Trial";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import ProfileSettings from "./pages/ProfileSettings";
import MyTopics from "./pages/MyTopics";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import DataServiceDetail from "./pages/DataServiceDetail";
import { VersionComparison } from "./components/VersionComparison";
import { MatomoTrackerProvider } from "./lib/matomo";
import RouteTracker from "./components/RouteTracker";
import Layout from "./components/Layout";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <MatomoTrackerProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <HashRouter>
          <Routes>
            <Route path="/" element={<Fragment> <RouteTracker /> <Index /> </Fragment>} />
            <Route path="/about" element={<Fragment> <RouteTracker /> <About /> </Fragment>} />
            <Route path="/products" element={<Fragment> <RouteTracker /> <Products /> </Fragment>} />
            <Route path="/manual" element={<Fragment> <RouteTracker /> <Manual /> </Fragment>} />
            <Route path="/cases" element={<Fragment> <RouteTracker /> <Cases /> </Fragment>} />
            <Route path="/community" element={<Fragment> <RouteTracker /> <Community /> </Fragment>} />
            <Route path="/community/topic/:id" element={<Fragment> <RouteTracker /> <TopicDetail /> </Fragment>} />
            <Route path="/contact" element={<Fragment> <RouteTracker /> <Contact /> </Fragment>} />
            <Route path="/trial" element={<Fragment> <RouteTracker /> <Trial /> </Fragment>} />
            <Route path="/register" element={<Fragment> <RouteTracker /> <Register /> </Fragment>} />
            <Route path="/login" element={<Fragment> <RouteTracker /> <Login /> </Fragment>} />
            <Route path="/profile" element={<Fragment> <RouteTracker /> <Profile /> </Fragment>} />
            <Route path="/profile/settings" element={<Fragment> <RouteTracker /> <ProfileSettings /> </Fragment>} />
            <Route path="/profile/topics" element={<Fragment> <RouteTracker /> <MyTopics /> </Fragment>} />
            <Route path="/version-comparison" element={<Fragment> <RouteTracker /> <Layout><VersionComparison /></Layout> </Fragment>} />
            <Route path="/data-service/:slug" element={<Fragment> <RouteTracker /> <DataServiceDetail /> </Fragment>} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<Fragment> <RouteTracker /> <NotFound /> </Fragment>} />
          </Routes>
        </HashRouter>
      </TooltipProvider>
    </MatomoTrackerProvider>
  </QueryClientProvider>
);

export default App;
